import { HIDDEN } from '../classnames/design-system';
import { FULL_PAGE_GALLERY_VISIBLE } from '../classnames/third-party-buttons';
import { replaceUrlParam } from '../utils/get-page-url';
import { isDesktop } from '../utils/media';
import {
  LARGE_PHOTO_SIZE,
  DESKTOP_PHOTOS_AMOUNT,
  MOBILE_PHOTOS_AMOUNT,
  SELECTORS,
  SMALL_PHOTO_SIZE
} from './constants';

export class PhotoCardSliderUI {
  constructor(utils) {
    this.utils = utils;
    this.modal = document.querySelector(`.${SELECTORS.SLIDER}`);
    this.prevButton = this.modal.querySelector(`.${SELECTORS.PREV_BTN}`);
    this.nextButton = this.modal.querySelector(`.${SELECTORS.NEXT_BTN}`);
    this.closeButton = this.modal.querySelector(`.${SELECTORS.CLOSE_BTN}`);
  }

  close = () => {
    this.modal.classList.add(HIDDEN);
    document.body.classList.remove(FULL_PAGE_GALLERY_VISIBLE);
  };

  open = () => {
    this.modal.classList.remove(HIDDEN);
    document.body.classList.add(FULL_PAGE_GALLERY_VISIBLE);
  };

  hideControllers = () => {
    this.prevButton.classList.add(HIDDEN);
    this.nextButton.classList.add(HIDDEN);
  };

  showControllers = () => {
    this.prevButton.classList.remove(HIDDEN);
    this.nextButton.classList.remove(HIDDEN);
  };

  updateImage = (src) => {
    this.modal.querySelector(`.${SELECTORS.IMG}`).src = replaceUrlParam(src, 'width', LARGE_PHOTO_SIZE);
  };

  updateContent = () => {
    this.utils.updateSliderContent();
  };

  create = (photos, onOpenSlider) => {
    const container = this.utils.getPhotosContainer();
    const photosAmount = isDesktop()
      ? DESKTOP_PHOTOS_AMOUNT
      : MOBILE_PHOTOS_AMOUNT;

    container.innerHTML = '';

    photos.slice(0, photosAmount).forEach((image, index) => {
      const thumbnail = document.createElement('img');
      thumbnail.src = replaceUrlParam(image, 'width', SMALL_PHOTO_SIZE);
      thumbnail.addEventListener('click', () => onOpenSlider(index));
      container.appendChild(thumbnail);
    });
  };
}
